import { DWSteps } from 'src/components/steps';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWSteps.displayName, DWSteps);

export default DWSteps;

export { DWSteps };
